import React from 'react';
import styled from 'styled-components';

interface IProps {
  children: JSX.Element[] | JSX.Element;
}

const TextCenterContainer: React.FC<IProps> = ({ children }) => {
  return <TextWrap>{children}</TextWrap>;
};

export default TextCenterContainer;
const TextWrap = styled.div`
  text-align: center;
  margin: 2rem 0 1rem;
`;
